/*******************************************************
OPEN TEAM VS POSITION MODAL
Used on the team vs. position page for NFL.
********************************************************/

import buildModal from '../../universal/modal-window/build-modal';

export default function openTeamVsPosModal(event) {
    const $button = $(event.currentTarget);
    const { id, firstname, lastname, pos, team, startweek, endweek, view } = $button.data();


    // Set the table loading message
    const loadingMessage = `Loading ${firstname} ${lastname} Stats`;

    // Build the title
    const modalTitle = `
    <div class="flex-row align-center">
        <img style="width:35px;margin-right:10px;" src="https://content.rotowire.com/images/teamlogo/football/100${team}.png"> ${firstname} ${lastname}
    </div>`;

    // Build the content of the modal
    const modalContent = `
        <div id="tt-table${id}">
            <div class="table-load"><div class="table-load__inner"><div class="loader"></div>${loadingMessage}</div></div>
        </div>`;

    // Get the modal window HTML
    const modalHTML = buildModal({
        fullWidth: true,
        title    : modalTitle,
        content  : modalContent,
    });

    const $allTable = $('#trendsALL');

    // Append the modal window to the page
    $('.page').append(modalHTML);

    if (view === 'percent') {

        loadTableRW({
            container   : `tt-table${id}`,
            url         : `/football/tables/team-trends-player.php?team=${team}&pos=${pos}&startweek=${startweek}&endweek=${endweek}&view=${view}&playerid=${id}`,
            emptyMessage: 'We do not have any stats to display at the moment.',
            leftSplit   : 1,
            css         : 'no-border',
            columns     : [

                { id           : 'stat',
                    header       : [{ text: '', css: 'columns-head is-dark' }, { text: 'Stat', css: 'align-l' }],
                    sort         : 'text-string',
                    sortDirection: 'asc',
                },

                { id    : 'avgStat',
                    header: [{ text: '', css: 'columns-head is-dark', colspan: 4 }, { text: 'Avg' }],
                    css   : 'align-r',
                    sort  : 'number',
                },
                { id    : 'total',
                    header: ['', { text: 'Total' }],
                    css   : 'align-r',
                    sort  : 'number',
                },
                { id    : 'minStat',
                    header: ['', { text: 'Min' }],
                    css   : 'align-r',
                    sort  : 'number',
                },
                { id    : 'maxStat',
                    header: ['', { text: 'Max' }],
                    css   : 'align-r',
                    sort  : 'number',
                },

                { id       : 'wk1',
                    header   : [{ text: '1', css: 'columns-head is-dark no-border-right' }, { text: $allTable.find('.wk1-game').text(), css: 'normal' }],
                    css      : 'align-r',
                    sort     : 'number',
                    cssFormat: formatCellRW('heatmap', { min: 0, max: 100, color: 'ro' }),
                },
                { id       : 'wk2',
                    header   : [{ text: '2', css: 'columns-head is-dark no-border-right' }, { text: $allTable.find('.wk2-game').text(), css: 'normal' }],
                    css      : 'align-r',
                    sort     : 'number',
                    cssFormat: formatCellRW('heatmap', { min: 0, max: 100, color: 'ro' }),
                },
                { id       : 'wk3',
                    header   : [{ text: '3', css: 'columns-head is-dark no-border-right' }, { text: $allTable.find('.wk3-game').text(), css: 'normal' }],
                    css      : 'align-r',
                    sort     : 'number',
                    cssFormat: formatCellRW('heatmap', { min: 0, max: 100, color: 'ro' }),
                },
                { id       : 'wk4',
                    header   : [{ text: '4', css: 'columns-head is-dark no-border-right' }, { text: $allTable.find('.wk4-game').text(), css: 'normal' }],
                    css      : 'align-r',
                    sort     : 'number',
                    cssFormat: formatCellRW('heatmap', { min: 0, max: 100, color: 'ro' }),
                },
                { id       : 'wk5',
                    header   : [{ text: '5', css: 'columns-head is-dark no-border-right' }, { text: $allTable.find('.wk5-game').text(), css: 'normal' }],
                    css      : 'align-r',
                    sort     : 'number',
                    cssFormat: formatCellRW('heatmap', { min: 0, max: 100, color: 'ro' }),
                },
                { id       : 'wk6',
                    header   : [{ text: '6', css: 'columns-head is-dark no-border-right' }, { text: $allTable.find('.wk6-game').text(), css: 'normal' }],
                    css      : 'align-r',
                    sort     : 'number',
                    cssFormat: formatCellRW('heatmap', { min: 0, max: 100, color: 'ro' }),
                },
                { id       : 'wk7',
                    header   : [{ text: '7', css: 'columns-head is-dark no-border-right' }, { text: $allTable.find('.wk7-game').text(), css: 'normal' }],
                    css      : 'align-r',
                    sort     : 'number',
                    cssFormat: formatCellRW('heatmap', { min: 0, max: 100, color: 'ro' }),
                },
                { id       : 'wk8',
                    header   : [{ text: '8', css: 'columns-head is-dark no-border-right' }, { text: $allTable.find('.wk8-game').text(), css: 'normal' }],
                    css      : 'align-r',
                    sort     : 'number',
                    cssFormat: formatCellRW('heatmap', { min: 0, max: 100, color: 'ro' }),
                },
                { id       : 'wk9',
                    header   : [{ text: '9', css: 'columns-head is-dark no-border-right' }, { text: $allTable.find('.wk9-game').text(), css: 'normal' }],
                    css      : 'align-r',
                    sort     : 'number',
                    cssFormat: formatCellRW('heatmap', { min: 0, max: 100, color: 'ro' }),
                },
                { id       : 'wk10',
                    header   : [{ text: '10', css: 'columns-head is-dark no-border-right' }, { text: $allTable.find('.wk10-game').text(), css: 'normal' }],
                    css      : 'align-r',
                    sort     : 'number',
                    cssFormat: formatCellRW('heatmap', { min: 0, max: 100, color: 'ro' }),
                },
                { id       : 'wk11',
                    header   : [{ text: '11', css: 'columns-head is-dark no-border-right' }, { text: $allTable.find('.wk11-game').text(), css: 'normal' }],
                    css      : 'align-r',
                    sort     : 'number',
                    cssFormat: formatCellRW('heatmap', { min: 0, max: 100, color: 'ro' }),
                },
                { id       : 'wk12',
                    header   : [{ text: '12', css: 'columns-head is-dark no-border-right' }, { text: $allTable.find('.wk12-game').text(), css: 'normal' }],
                    css      : 'align-r',
                    sort     : 'number',
                    cssFormat: formatCellRW('heatmap', { min: 0, max: 100, color: 'ro' }),
                },
                { id       : 'wk13',
                    header   : [{ text: '13', css: 'columns-head is-dark no-border-right' }, { text: $allTable.find('.wk13-game').text(), css: 'normal' }],
                    css      : 'align-r',
                    sort     : 'number',
                    cssFormat: formatCellRW('heatmap', { min: 0, max: 100, color: 'ro' }),
                },
                { id       : 'wk14',
                    header   : [{ text: '14', css: 'columns-head is-dark no-border-right' }, { text: $allTable.find('.wk14-game').text(), css: 'normal' }],
                    css      : 'align-r',
                    sort     : 'number',
                    cssFormat: formatCellRW('heatmap', { min: 0, max: 100, color: 'ro' }),
                },
                { id       : 'wk15',
                    header   : [{ text: '15', css: 'columns-head is-dark no-border-right' }, { text: $allTable.find('.wk15-game').text(), css: 'normal' }],
                    css      : 'align-r',
                    sort     : 'number',
                    cssFormat: formatCellRW('heatmap', { min: 0, max: 100, color: 'ro' }),
                },
                { id       : 'wk16',
                    header   : [{ text: '16', css: 'columns-head is-dark no-border-right' }, { text: $allTable.find('.wk16-game').text(), css: 'normal' }],
                    css      : 'align-r',
                    sort     : 'number',
                    cssFormat: formatCellRW('heatmap', { min: 0, max: 100, color: 'ro' }),
                },
                { id       : 'wk17',
                    header   : [{ text: '17', css: 'columns-head is-dark no-border-right' }, { text: $allTable.find('.wk17-game').text(), css: 'normal' }],
                    css      : 'align-r',
                    sort     : 'number',
                    cssFormat: formatCellRW('heatmap', { min: 0, max: 100, color: 'ro' }),
                },
            ],
        });

    }
    else {

        loadTableRW({
            container   : `tt-table${id}`,
            url         : `/football/tables/team-trends-player.php?team=${team}&pos=${pos}&startweek=${startweek}&endweek=${endweek}&view=${view}&playerid=${id}`,
            emptyMessage: 'We do not have any stats to display at the moment.',
            leftSplit   : 1,
            css         : 'no-border',
            columns     : [

                { id           : 'stat',
                    header       : [{ text: '', css: 'columns-head is-dark' }, { text: 'Stat', css: 'align-l' }],
                    sort         : 'text-string',
                    sortDirection: 'asc',
                },

                { id    : 'avgStat',
                    header: [{ text: '', css: 'columns-head is-dark', colspan: 4 }, { text: 'Avg' }],
                    css   : 'align-r',
                    sort  : 'number',
                },
                { id    : 'total',
                    header: ['', { text: 'Total' }],
                    css   : 'align-r',
                    sort  : 'number',
                },
                { id    : 'minStat',
                    header: ['', { text: 'Min' }],
                    css   : 'align-r',
                    sort  : 'number',
                },
                { id    : 'maxStat',
                    header: ['', { text: 'Max' }],
                    css   : 'align-r',
                    sort  : 'number',
                },

                { id    : 'wk1',
                    header: [{ text: '1', css: 'columns-head is-dark' }, { text: $allTable.find('.wk1-game').text(), css: 'normal' }],
                    css   : 'align-r',
                    sort  : 'number',
                },
                { id    : 'wk2',
                    header: [{ text: '2', css: 'columns-head is-dark' }, { text: $allTable.find('.wk2-game').text(), css: 'normal' }],
                    css   : 'align-r',
                    sort  : 'number',
                },
                { id    : 'wk3',
                    header: [{ text: '3', css: 'columns-head is-dark' }, { text: $allTable.find('.wk3-game').text(), css: 'normal' }],
                    css   : 'align-r',
                    sort  : 'number',
                },
                { id    : 'wk4',
                    header: [{ text: '4', css: 'columns-head is-dark' }, { text: $allTable.find('.wk4-game').text(), css: 'normal' }],
                    css   : 'align-r',
                    sort  : 'number',
                },
                { id    : 'wk5',
                    header: [{ text: '5', css: 'columns-head is-dark' }, { text: $allTable.find('.wk5-game').text(), css: 'normal' }],
                    css   : 'align-r',
                    sort  : 'number',
                },
                { id    : 'wk6',
                    header: [{ text: '6', css: 'columns-head is-dark' }, { text: $allTable.find('.wk6-game').text(), css: 'normal' }],
                    css   : 'align-r',
                    sort  : 'number',
                },
                { id    : 'wk7',
                    header: [{ text: '7', css: 'columns-head is-dark' }, { text: $allTable.find('.wk7-game').text(), css: 'normal' }],
                    css   : 'align-r',
                    sort  : 'number',
                },
                { id    : 'wk8',
                    header: [{ text: '8', css: 'columns-head is-dark' }, { text: $allTable.find('.wk8-game').text(), css: 'normal' }],
                    css   : 'align-r',
                    sort  : 'number',
                },
                { id    : 'wk9',
                    header: [{ text: '9', css: 'columns-head is-dark' }, { text: $allTable.find('.wk9-game').text(), css: 'normal' }],
                    css   : 'align-r',
                    sort  : 'number',
                },
                { id    : 'wk10',
                    header: [{ text: '10', css: 'columns-head is-dark' }, { text: $allTable.find('.wk10-game').text(), css: 'normal' }],
                    css   : 'align-r',
                    sort  : 'number',
                },
                { id    : 'wk11',
                    header: [{ text: '11', css: 'columns-head is-dark' }, { text: $allTable.find('.wk11-game').text(), css: 'normal' }],
                    css   : 'align-r',
                    sort  : 'number',
                },
                { id    : 'wk12',
                    header: [{ text: '12', css: 'columns-head is-dark' }, { text: $allTable.find('.wk12-game').text(), css: 'normal' }],
                    css   : 'align-r',
                    sort  : 'number',
                },
                { id    : 'wk13',
                    header: [{ text: '13', css: 'columns-head is-dark' }, { text: $allTable.find('.wk13-game').text(), css: 'normal' }],
                    css   : 'align-r',
                    sort  : 'number',
                },
                { id    : 'wk14',
                    header: [{ text: '14', css: 'columns-head is-dark' }, { text: $allTable.find('.wk14-game').text(), css: 'normal' }],
                    css   : 'align-r',
                    sort  : 'number',
                },
                { id    : 'wk15',
                    header: [{ text: '15', css: 'columns-head is-dark' }, { text: $allTable.find('.wk15-game').text(), css: 'normal' }],
                    css   : 'align-r',
                    sort  : 'number',
                },
                { id    : 'wk16',
                    header: [{ text: '16', css: 'columns-head is-dark' }, { text: $allTable.find('.wk16-game').text(), css: 'normal' }],
                    css   : 'align-r',
                    sort  : 'number',
                },
                { id    : 'wk17',
                    header: [{ text: '17', css: 'columns-head is-dark' }, { text: $allTable.find('.wk17-game').text(), css: 'normal' }],
                    css   : 'align-r',
                    sort  : 'number',
                },
            ],
        });

    }

}
